import React from "react";
import {IProduct} from 'data/interfaces/products';
import {MDBCol, MDBRow} from 'mdbreact';
import {IOrder} from 'data/interfaces/orders';

export interface IPreSaleConclusionProps {
  product?: IProduct;
  order?: IOrder;
}
const SaleDetails = (props: IPreSaleConclusionProps) => (
  <div className="saleDetailsContainer">
    <MDBRow className="type" style={{marginTop: 20, fontSize: "1em"}}>
      <MDBCol className="label" sm="8" style={{fontWeight: 500}}>
        סוג:
      </MDBCol>
      <MDBCol className="value disableWordBreak"
              sm="4"
              style={{textAlign: 'end'}}>
        {props.product.ticketDetails.isRoundTripTicket ? "הלוך חזור" : "כיוון אחד"}
      </MDBCol>
    </MDBRow>
    <MDBRow style={{marginTop: 10, fontSize: "1em"}}>
      <MDBCol className="label" sm="8" style={{fontWeight: 500}}>
        כרטיסים:
      </MDBCol>
      <MDBCol className="value disableWordBreak"
              sm="4"
              style={{textAlign: 'end'}}>
        {props.product.ticketDetails.ticketsAmount}

      </MDBCol>
    </MDBRow>
  </div>
);

SaleDetails.defaultProps = {
  product: {},
};

export default React.memo(SaleDetails);
